import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/macro';
import { Heading2 } from '@qover/typography';
import { InputDateField } from '@qover/molecules';

const Container = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.cardBackground()};
  color: ${({ theme }) => theme.colors.textQuote()};
  display: flex;
  flex-direction: column;
  padding: 40px;
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.maxWidth.XS}) {
    padding: 20px;
  }

  > div {
    width: 100%;
    max-width: 360px;
  }

  &.dark {
    background-color: ${({ theme }) => theme.colors.textQuote(0.05)};
  }
`;

type ContractDateProps = {
  className?: string;
  locale: string;
  maxDate: Date;
  minDate: Date;
  prefix?: string;
  title: React.ReactNode;
};

export function ContractDate(props: ContractDateProps) {
  return (
    <Container className={props.className}>
      <Heading2 className="text-center">{props.title}</Heading2>
      <InputDateField
        data-test={`${props.prefix}startDate`}
        id={`${props.prefix}startDate`}
        label={<Trans id="general.startDate" />}
        locale={props.locale}
        maxDate={props.maxDate}
        minDate={props.minDate}
        name={`${props.prefix}startDate`}
      />
    </Container>
  );
}

ContractDate.defaultProps = {
  prefix: '',
};
